import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routes: Routes = [
  { 
    path: 'admin', loadChildren: () => import('./admin/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule) 
  },
  {
    path: '', loadChildren: () => import('./system/layout/layout.module').then(m => m.LayoutModule) 
  },
  {
    path: '404', component: NotFoundComponent
  },
  {
    path: '**', redirectTo: '/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
